import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiService from "../Common/Configurations/APIService";
import config from "../Common/Configurations/APIConfig";
// KEY CHANGE 1: Import DefaultData for consistent theme colors and branding
import DefaultData from "../CompanyData/DefaultData";

// KEY CHANGE 2: Added the features array for the left-side display
const features = [
    { icon: 'ri-flight-takeoff-line', name: 'Flights' }, { icon: 'ri-building-line', name: 'Hotels' },
    { icon: 'ri-car-line', name: 'Cars' }, { icon: 'ri-bus-2-line', name: 'Bus' },
    { icon: 'ri-suitcase-line', name: 'Holidays' }, { icon: 'ri-visa-line', name: 'Visas' },
    { icon: 'ri-magic-line', name: 'AI Packages' }, { icon: 'ri-whatsapp-line', name: 'AI Chatbot' },
    { icon: 'ri-user-add-line', name: 'Leads' }, { icon: 'ri-global-line', name: 'Website' },
    { icon: 'ri-bar-chart-line', name: 'Analytics' }, { icon: 'ri-customer-service-2-line', name: 'Support' },
];

export default function ConfirmEmail() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [email, setEmail] = useState(true);
  const [token, setToken] = useState(true);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const handleSubmit = async () => {};
  const handleVerify = async (email, token) => {
    setLoading(true);
    const formData = {
      email: email,
      token: token.trim(),
      domainUrl: window.location.origin,
    };
    try {
      const result = await apiService.post(config.VERIFYCOMPANY, formData);
      setLoading(false);
      if (result.statusCode === 200) {
        setStatus(true);
      } else {
        setStatus(false);
      }
    } catch (error) {
      console.error("Reset failed:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchParams === null) {
      navigate("/");
    } else {
      setEmail(searchParams.get("email"));
      var letparams = searchParams.toString();
      var splitparams = letparams.split("=");
      setToken(splitparams[2]);
      handleVerify(searchParams.get("email"), splitparams[2]);
    }
  }, []);


  // KEY CHANGE 3: The entire JSX is replaced with the new, modern layout.
  return (
    <div style={{ backgroundColor: DefaultData.THEMECOLOR1, minHeight: '100vh' }}>
      <div className="container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <div className="row align-items-center w-100">

          {/* Left Column: Branding and Features */}
          <div className="col-lg-7 text-center text-lg-start mb-5 mb-lg-0 d-none d-lg-block">
              <h1 className="display-6 fw-bolder mb-3" style={{ color: DefaultData.THEMECOLOR2 }}>{DefaultData.LANDINGPAGETITLE}</h1>
              <p className="fs-5 mb-5" style={{ color: DefaultData.THEMECOLOR2, opacity: 0.9 }}>{DefaultData.LANDINGPAGESUBTITLE}</p>
              <div className="row row-cols-6 justify-content-center justify-content-lg-start g-4">
                  {features.map((feature) => (
                      <div className="col" key={feature.name}>
                          <div className="text-center">
                              <div style={{ width: '70px', height: '70px', borderRadius: '50%', backgroundColor: DefaultData.THEMECOLOR3, display: 'flex', alignItems: 'center', justifyContent: 'center', color: DefaultData.THEMECOLOR2, marginBottom: '0.5rem', margin: '0 auto' }}>
                                  <i className={`${feature.icon} fs-2`}></i>
                              </div>
                              <span className="fw-semibold" style={{ color: DefaultData.THEMECOLOR2 }}>{feature.name}</span>
                          </div>
                      </div>
                  ))}
              </div>
          </div>

          {/* Right Column: The Status Card */}
          <div className="col-lg-5 d-flex justify-content-center justify-content-lg-end">
            <div className="card shadow-lg border-0" style={{ borderRadius: '1rem', width: '100%', maxWidth: '450px' }}>
              <div className="card-body p-lg-5 p-4 text-center">
                
                {loading ? (
                    // Loading State
                    <div>
                        <div className="spinner-border" style={{color: DefaultData.THEMECOLOR2}} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <h5 className="mt-3">Verifying your Email...</h5>
                        <p className="text-muted">Please wait a moment.</p>
                    </div>
                ) : status ? (
                    // Success State
                    <div>
                        <div className="mb-4">
                            <i className="ri-checkbox-circle-line text-success" style={{ fontSize: '4rem' }}></i>
                        </div>
                        <h4 className="mb-2">Email Verified!</h4>
                        <p className="text-muted mb-4">Congratulations! Your account is now active and ready to use.</p>
                        <Link to="/" className="btn w-100 fw-bold" style={{ backgroundColor: DefaultData.THEMECOLOR1, color: DefaultData.THEMECOLOR4 }}>
                            Continue to Sign In
                        </Link>
                    </div>
                ) : (
                    // Failure State
                    <div>
                        <div className="mb-4">
                            <i className="ri-error-warning-line text-danger" style={{ fontSize: '4rem' }}></i>
                        </div>
                        <h4 className="mb-2">Verification Failed</h4>
                        <p className="text-muted mb-4">The verification link is either invalid or has expired. Please request a new one.</p>
                        <button onClick={handleSubmit} className="btn w-100 fw-bold" style={{ backgroundColor: DefaultData.THEMECOLOR1, color: DefaultData.THEMECOLOR4 }}>
                            Resend Link
                        </button>
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}